// Vumatel packages
export const vumatelPackages = [
  // Regular Vumatel Packages
  {
    ID: 2802800,
    Title: "Vumatel 50/50Mbps - Vuma FTTH By WonderNet",
    Price: 789.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Vumatel",
    ISP: "Wondernet"
  },
  {
    ID: 2802802,
    Title: "Vumatel 100/100Mbps - Vuma FTTH By WonderNet",
    Price: 979.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Vumatel",
    ISP: "Wondernet"
  },
  {
    ID: 2802804,
    Title: "Vumatel 200/200Mbps - Vuma FTTH By WonderNet",
    Price: 1135.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Vumatel",
    ISP: "Wondernet"
  },
  {
    ID: 5711016,
    Title: "Vumatel 1000/250Mbps - Vuma FTTH By WonderNet",
    Price: 1489.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 256000,
    Supplier: "Vumatel",
    ISP: "Wondernet"
  },
  {
    ID: 15985305,
    Title: "Vumatel 500/200Mbps - Vuma FTTH By WonderNet",
    Price: 1269.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 204800,
    Supplier: "Vumatel",
    ISP: "Wondernet"
  },
  
  // Vumatel Tactical Packages
  {
    ID: 22559820,
    Title: "Vumatel 30/30Mbps - Vuma FTTH By WonderNet (Tactical)",
    Price: 499.00,
    "Download speed (kbps)": 30720,
    "Upload speed (kbps)": 30720,
    Supplier: "Vumatel Tactical",
    ISP: "Wondernet"
  },
  {
    ID: 22559830,
    Title: "Vumatel 50/25Mbps FTTH By WonderNet",
    Price: 679.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 25600,
    Supplier: "Vumatel Tactical",
    ISP: "Wondernet"
  },
  {
    ID: 22559831,
    Title: "Vumatel 100/50Mbps - Vuma FTTH By WonderNet (Tactical)",
    Price: 879.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 51200,
    Supplier: "Vumatel Tactical",
    ISP: "Wondernet"
  }
];